import Vue from 'vue';
import axios from 'axios';

export const appService = {
  getSession: function() {
    return Vue.axios.get('/session').then(response => {
      return response.data;
    });
  },
  refreshSession: function() {
    return Vue.axios.get(axios.defaults.sessionRefresh).then(response => response);
  },

  getGlobalValues() {
    return Vue.axios.get('/globals').then(response => response.data);
  },

  getUnreadNotificationCount() {
    return Vue.axios.get('/notifications/unread-count').then(response => response.data);
  },
  logoutSession: function() {
    return Vue.axios.post('/session/logout');
  },
  getServiceAlive() {
    return Vue.axios.get('/session/alive').then(response => response.data);
  }
};
